import { useState } from 'react';
import { useAuth } from 'auth/AuthContext';
import 'styles/login.css';

// Formulaire de connexion, responsive (identique pour les versions mobile et desktop)
function Login() {
  const { login, error } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!username || !password || submitting) return;
    setSubmitting(true);
    await login(username, password);
    setSubmitting(false);
  };

  return (
    <div className="LoginPage">
      <form className="LoginForm" onSubmit={handleSubmit}>
        <h1 className="LoginTitle">Rentman</h1>
        <label className="LoginLabel">
          Identifiant
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoFocus
          />
        </label>
        <label className="LoginLabel">
          Mot de passe
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </label>
        {error && <div className="LoginError">{error}</div>}
        <button className="LoginButton" type="submit" disabled={submitting}>
          {submitting ? 'Connexion…' : 'Se connecter'}
        </button>
      </form>
    </div>
  );
}

export default Login;
